var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"line"},[(_vm.errors && _vm.errors.length > 0)?_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error,staticClass:"error"},[_vm._v(_vm._s(error))])}),0):_vm._e(),_c('LoadingWidget',{attrs:{"loadWidget":_vm.showLoading}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }